
import crud from "./_crud";

const actions = crud('service', 'el servicio', 'los servicios');

export default actions